
import { Module, MutationTree } from 'vuex'
import { RootState } from '@/store'

export type ConfigState = {
  providerFrontendUrl: string | null;
  customerFrontendUrl: string | null;
  stripePublishable: string | null;
  sourceSystem: string | null;
  websocketUrl: string | null;
  minTemplatePrice: number;
  minCorrectionPrice: number;
  minFullTranslationPrice: number;
}

class ConfigStore implements Module<ConfigState, RootState> {
  namespaced = true

  state: () => ConfigState = () => ({
    providerFrontendUrl: null,
    customerFrontendUrl: null,
    websocketUrl: null,
    stripePublishable: null,
    sourceSystem: null,
    minTemplatePrice: 0,
    minCorrectionPrice: 0,
    minFullTranslationPrice: 0
  })

  mutations: MutationTree<ConfigState> = {
    update(state, newData) {
      state.providerFrontendUrl = newData.providerFrontendUrl
      state.customerFrontendUrl = newData.customerFrontendUrl
      state.stripePublishable = newData.stripePublishable
      state.sourceSystem = newData.sourceSystem 
      state.websocketUrl = newData.websocketUrl
      state.minTemplatePrice = newData.minTemplatePrice
      state.minCorrectionPrice = newData.minCorrectionPrice
      state.minFullTranslationPrice = newData.minFullTranslationPrice
    }
  }
}

export default new ConfigStore()
